"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XPOUQO6Mcjs = require('../__chunks/XPOUQO6M.cjs');


var _BSDSNAGPcjs = require('../__chunks/BSDSNAGP.cjs');
require('../__chunks/RF45TVVP.cjs');


var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/STJK5WUW.cjs');
require('../__chunks/B5WROPFJ.cjs');


var _D7QSSCKRcjs = require('../__chunks/D7QSSCKR.cjs');
require('../__chunks/55GZX7VJ.cjs');
require('../__chunks/UI5KWBYV.cjs');
require('../__chunks/L634CRNJ.cjs');
require('../__chunks/MXP46NZ2.cjs');
require('../__chunks/5MLKOK3F.cjs');
require('../__chunks/YEIU6ILA.cjs');
require('../__chunks/W32FX7DM.cjs');
require('../__chunks/7AMN26AR.cjs');
require('../__chunks/6GRO3ZM4.cjs');
require('../__chunks/VP4WDOZF.cjs');
require('../__chunks/55HRZINU.cjs');
require('../__chunks/2UJOY5ZF.cjs');
require('../__chunks/JLMLKTUB.cjs');
require('../__chunks/LCWSLOYU.cjs');
require('../__chunks/V7JASX7S.cjs');
require('../__chunks/56NPFF7P.cjs');
require('../__chunks/GASMO7Y4.cjs');
require('../__chunks/6IFEN2M3.cjs');
require('../__chunks/26P4PLHI.cjs');
require('../__chunks/YVOQ2BCB.cjs');
require('../__chunks/4SKDRUBR.cjs');
require('../__chunks/AQ2LO7WV.cjs');
require('../__chunks/KEDCOTT4.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/6E4BBKC4.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/VYZTFWCG.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu.tsx
var _events = require('@ariakit/core/utils/events');
var _focus = require('@ariakit/core/utils/focus');
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "div";
var useMenu = _PTOCUU2Dcjs.createHook.call(void 0, function useMenu2({
  store,
  modal: modalProp = false,
  portal = !!modalProp,
  hideOnEscape = true,
  autoFocusOnShow = true,
  hideOnHoverOutside,
  alwaysVisible,
  ...props
}) {
  const context = _XXF5DFSGcjs.useMenuProviderContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component."
  );
  const ref = _react.useRef.call(void 0, null);
  const parentMenu = store.parent;
  const parentMenubar = store.menubar;
  const hasParentMenu = !!parentMenu;
  const parentIsMenubar = !!parentMenubar && !hasParentMenu;
  const modal = hasParentMenu ? false : modalProp;
  props = {
    ...props,
    ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref)
  };
  const { "aria-labelledby": ariaLabelledBy, ...menuListProps } = _XPOUQO6Mcjs.useMenuList.call(void 0, {
    store,
    alwaysVisible,
    ...props
  });
  props = menuListProps;
  const [initialFocusRef, setInitialFocusRef] = _react.useState.call(void 0, );
  const autoFocusOnShowState = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "autoFocusOnShow");
  const initialFocus = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "initialFocus");
  const baseElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "baseElement");
  const items = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "renderedItems");
  _react.useEffect.call(void 0, () => {
    let cleaning = false;
    setInitialFocusRef((prevInitialFocusRef) => {
      var _a, _b, _c;
      if (cleaning) return;
      if (modal && ((_a = prevInitialFocusRef == null ? void 0 : prevInitialFocusRef.current) == null ? void 0 : _a.isConnected)) {
        return prevInitialFocusRef;
      }
      if (!autoFocusOnShowState) return;
      let element;
      switch (initialFocus) {
        // TODO: Refactor
        case "first":
          element = ((_b = items.find((item) => !item.disabled && item.element)) == null ? void 0 : _b.element) || null;
          break;
        case "last":
          element = ((_c = [...items].reverse().find((item) => !item.disabled && item.element)) == null ? void 0 : _c.element) || null;
          break;
        default:
          element = baseElement;
      }
      if (element && element === (prevInitialFocusRef == null ? void 0 : prevInitialFocusRef.current)) {
        return prevInitialFocusRef;
      }
      const ref2 = _react.createRef.call(void 0, );
      ref2.current = element;
      return ref2;
    });
    return () => {
      cleaning = true;
    };
  }, [store, modal, autoFocusOnShowState, initialFocus, items, baseElement]);
  const mayAutoFocusOnShow = !!autoFocusOnShow;
  const canAutoFocusOnShow = !!initialFocusRef || !!props.initialFocus || !!modal;
  const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store.combobox || store,
    "contentElement"
  );
  const parentContentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    (parentMenu == null ? void 0 : parentMenu.combobox) || parentMenu,
    "contentElement"
  );
  const preserveTabOrderAnchor = _react.useMemo.call(void 0, () => {
    if (!parentContentElement) return;
    if (!contentElement) return;
    const role = contentElement.getAttribute("role");
    const parentRole = parentContentElement.getAttribute("role");
    const parentIsMenuOrMenubar = parentRole === "menu" || parentRole === "menubar";
    if (parentIsMenuOrMenubar && role === "menu") return;
    return parentContentElement;
  }, [contentElement, parentContentElement]);
  if (preserveTabOrderAnchor !== void 0) {
    props = {
      preserveTabOrderAnchor,
      ...props
    };
  }
  props = _BSDSNAGPcjs.useHovercard.call(void 0, {
    store,
    alwaysVisible,
    initialFocus: initialFocusRef,
    autoFocusOnShow: mayAutoFocusOnShow ? canAutoFocusOnShow && autoFocusOnShow : autoFocusOnShowState || !!modal,
    ...props,
    hideOnEscape(event) {
      if (_misc.isFalsyBooleanCallback.call(void 0, hideOnEscape, event)) return false;
      store == null ? void 0 : store.hideAll();
      return true;
    },
    hideOnHoverOutside(event) {
      const disclosureElement = store == null ? void 0 : store.getState().disclosureElement;
      const getHideOnHoverOutside = () => {
        if (typeof hideOnHoverOutside === "function") {
          return hideOnHoverOutside(event);
        }
        if (hideOnHoverOutside != null) return hideOnHoverOutside;
        if (hasParentMenu) return true;
        if (!parentIsMenubar) return false;
        if (!disclosureElement) return true;
        if (_focus.hasFocusWithin.call(void 0, disclosureElement)) return false;
        return true;
      };
      if (!getHideOnHoverOutside()) return false;
      if (event.defaultPrevented) return true;
      if (!hasParentMenu) return true;
      if (!disclosureElement) return true;
      _events.fireEvent.call(void 0, disclosureElement, "mouseout", event);
      if (!_focus.hasFocusWithin.call(void 0, disclosureElement)) return true;
      requestAnimationFrame(() => {
        if (_focus.hasFocusWithin.call(void 0, disclosureElement)) return;
        store == null ? void 0 : store.hide();
      });
      return false;
    },
    modal,
    portal,
    backdrop: hasParentMenu ? false : props.backdrop
  });
  props = {
    "aria-labelledby": ariaLabelledBy,
    ...props
  };
  return props;
});
var Menu = _D7QSSCKRcjs.createDialogComponent.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function Menu2(props) {
    const htmlProps = useMenu(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  }),
  _XXF5DFSGcjs.useMenuProviderContext
);



exports.Menu = Menu; exports.useMenu = useMenu;
